import { Modal } from "./modal";
import { Ajax } from "../ajax";


// *************************************************************************
// Třída s modálním dialogem, který má obsah se kterým budeme programově pracovat
// (jinak nám stačí "obyčejná" třída Modal).
//
// ModalWindow není předáván do veřejného namespace (není to zatím potřeba).
// *************************************************************************

//
// Třída ModalWindow dědí od třídy Modal.
//
export function ModalWindow(element) {
	Modal.call(this, element);
}
ModalWindow.prototype = Object.create(Modal.prototype);
ModalWindow.prototype.constructor = ModalWindow;


//
// Vytvoří modální dialog i s obsahem.
//
ModalWindow.create = function() {
	return Modal.create();
}


//
// Vytvoří nebo vrátí existující instanci modálního dialogu.
//
ModalWindow.get = function(element) {
	return Modal.get(element, ModalWindow);
}

//
// Vytvoří modální okno z AJAXového požadavku na danou url.
// V současné době se pouze GETem zavolá daná URL, nic dalšího "složitého".
// Při čekání zobrazí spinner, aby uživatel měl povědomí o tom, že se něco děje.
// Ajaxová odpověď může obsahovat speciální HTTP hlavičku "Ajax-Modal-Class" s libovolnými CSS třídami,
// které se přidají k modálnímu oknu (např. třídu "modal-lg" pro větší modální okno).
//
ModalWindow.openAjax = function(url) {
	// Připravíme si modální okno.
	var modal = ModalWindow.get();

	// Zobrazíme spinner.
	modal.element.classList.add("sending-request");
	modal.open();

	// Nejprve načteme data
	Ajax.get(url, { "Ajax-Modal-Requested-With": "ModalWindow" }).then(function(data) {
		let event = data.event;
		let xhr = data.xhr;

		modal.element.classList.remove("sending-request");
		modal.element.innerHTML = event.target.response;

		// Přidáváme nový obsah, emitujme proto událost "snippet ready".
		modal.element.trigger("snippetready", { parent: modal.element }, true);
	}).catch(function() {
		modal.element.classList.remove("sending-request");
		modal.element.innerHTML = "Při vyřizování požadavku došlo k chybě.";
	});
}


// *************************************************************************
// Události.
// *************************************************************************

//
// Přidá možnost označovat odkazy data atributem data-modal="ajax", kdy se výsledek
// AJAXu zobrazí v modálním okně.
//
document.addEventSelectorListener("click", "[data-modal='window'], [data-modal='window close']", function(event, target) {
	if (target.getAttribute("data-modal") == "ajax close") {
		event.preventDefault();
		Modal.get(target).close();
	}

	var href = target.getAttribute("href") || target.getAttribute("data-href");
	if (href) {
		event.preventDefault();
		ModalWindow.openAjax(href);
	}
});

//
// Uzavření modálního okna kliknutím na černé pozadí.
//
document.addEventMatchesListener("click", ".modal-dialog", function(event, target) {
	let modal = ModalWindow.get(target);
	if (!modal.isNoClose) {
		event.preventDefault();
		modal.close();
	}
});


// *************************************************************************
// Publikujeme do veřejného namespace.
// *************************************************************************

export default ModalWindow;
